const FIELD_LABELS: Record<string, string> = {
  external_account: 'Bank account',
  'individual.verification.document': 'Identity document (photo ID)',
  'individual.verification.additional_document': 'Additional identity document',
  'individual.dob.day': 'Date of birth',
  'individual.dob.month': 'Date of birth',
  'individual.dob.year': 'Date of birth',
  'individual.ssn_last_4': 'Social Security Number (last 4 digits)',
  'individual.id_number': 'Social Security Number',
  'individual.first_name': 'Legal first name',
  'individual.last_name': 'Legal last name',
  'individual.email': 'Email address',
  'individual.phone': 'Phone number',
  'individual.address.line1': 'Home address',
  'individual.address.city': 'City',
  'individual.address.state': 'State',
  'individual.address.postal_code': 'ZIP code',
  'tos_acceptance.date': 'Terms of Service acceptance',
  'tos_acceptance.ip': 'Terms of Service acceptance',
  'business_profile.url': 'Business website URL',
  'business_profile.mcc': 'Business category'
};

export function getReadableRequirements(fields: string[]): string[] {
  return [...new Set(fields.map((f) => FIELD_LABELS[f] ?? f))];
}

export function humanizeFields(fields: string[]): string {
  const labels = getReadableRequirements(fields);
  if (labels.length === 0) return 'required information';
  if (labels.length === 1) return labels[0];
  return labels.slice(0, -1).join(', ') + ' and ' + labels[labels.length - 1];
}
